import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson34: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson33"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">{`Carbohydrate Mystery `}</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson35"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch relative text-[1.56rem] tracking-[0.02em] leading-[2rem] text-gainsboro-100">
          <p className="m-0">
            In the previous chapter, we emphasized the importance of protein
            quality and distribution for maximizing progress. In this chapter,
            we will explore a similar topic, but this time focusing on
            carbohydrates.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Carbohydrates are classified as a non-essential macronutrient.
            Unlike protein and certain fats, it is technically possible to
            survive without consuming any carbs for the rest of your life.
            Moreover, carbohydrates do not possess the same anabolic properties
            as protein, as they do not directly influence muscle protein
            synthesis.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            However, carbohydrates still play a vital role in the process of
            body recomposition. They provide the necessary fuel for training
            performance, which ultimately drives muscle growth. Additionally,
            different types of carbohydrates can have varying effects on factors
            such as hunger, digestion, and mood, all of which we will delve into
            in this chapter.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>The Best Carb Sources For Recomp</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                In a previous chapter, we highlighted the importance of
                recognizing that not all proteins are equal. Similarly, we want
                to emphasize that not all carbohydrates are created equal in
                this chapter.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It's essential to clarify our stance here. When it comes to
                simple weight loss goals, you can certainly treat all carbs as
                the same, and the caloric deficit will drive the weight loss.
                For instance, substituting brown rice with Gatorade may not
                significantly impact your weight loss progress.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, such a swap could potentially have negative effects on
                other factors like training performance and adherence to the
                diet plan.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                We encourage you to avoid viewing carbohydrates in binary terms
                (good or bad) or considering them completely interchangeable.
                Instead, we want to shed light on the various shades of grey in
                understanding carbohydrates.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Before delving into the best carbohydrate sources for fueling
                training, it's crucial to grasp the basic science behind
                carbohydrates from a structural perspective. This understanding
                will help us provide more practical recommendations.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                All carbohydrates share a few common characteristics: they
                consist of carbon, hydrogen, and oxygen atoms (hence the name
                "Carb-OH-hydrates"), they retain about three grams of water per
                gram when stored as muscle glycogen, and they generally taste
                delicious.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Carbohydrates can be categorized in various ways, but for our
                purposes here, we will focus on two classifications: simple
                versus complex carbs and high glycemic versus low glycemic
                carbs.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[54.31rem] object-cover"
          alt=""
          src="/214@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Simple vs Complex Carbs</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When we refer to "simple carbs," we are essentially describing
                carbohydrates that are small and uncomplicated. These types of
                carbohydrates are primarily composed of sugars.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                There are numerous varieties of sugars, and the simplest among
                them are known as mono-saccharides. The prefix "mono" indicates
                "alone," and "saccharide" is a scientific term for sugar. There
                are only three mono-saccharides that exist independently:
                glucose, which serves as our body's primary energy source under
                normal conditions ; fructose, which is found in fruits; and
                galactose, the predominant sugar in dairy products.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Within specific food sources, these monosaccharides have the
                ability to join together, forming pairs known as di-saccharides.
                As the prefix "di" suggests, this involves two of the
                aforementioned sugars combining to create a slightly larger
                sugar molecule.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Despite their slightly increased size, we still categorize these
                sugar pairs as simple carbs.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                While it's not necessary to delve into the intricacies of
                chemistry to make informed food choices, it is valuable to grasp
                the basic concept of what characterizes a simple carbohydrate as
                "simple." Due to their small size, simple carbs can be rapidly
                absorbed by the body without requiring extensive digestion.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                This understanding will prove significant when we delve into the
                discussion of pre, intra, and post-workout nutrition . Examples
                of simple carbs include candy, table sugar, the sugar present in
                milk, and the sugar found in fruit (although fruit also contains
                complex carbs).
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In contrast, complex carbs are considerably larger and more
                substantial. They consist of chains of simple sugars linked
                together, forming what we refer to as poly-saccharides. The term
                "poly" signifies many, while "saccharide" denotes sugar.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Due to their larger and often intricate structure, complex carbs
                necessitate the process of digestion to break them down into
                their smaller, simple components before they can be absorbed and
                utilized as energy. This has two noteworthy implications: First,
                complex carbs are absorbed at a slower rate, extending the
                duration of their release—a factor worth considering when we
                delve into carb timing in next chapters. Second, complex carbs
                exhibit a higher thermic effect, which refers to the number of
                calories the body expends to break down the consumed food.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Examples of complex carbs encompass a range of foods such as
                whole grains, vegetables, legumes, rice, and pasta.
              </span>
            </span>
          </p>
        </div>
        <img
          className="relative w-[96.75rem] h-[95.31rem] object-cover"
          alt=""
          src="/215@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How Much Sugar is Okay ?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  To avoid potential crashes during training, we recommend
                  consuming foods like ice cream, cookies, and sugary cereals in
                  moderation and at a time when they are less likely to affect
                  your performance. For example, including these foods as part
                  of a post-workout meal would be more suitable than a
                  pre-workout meal.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Additionally, we suggest keeping daily sugar intake to
                  approximately 100 grams as a general guideline. However,
                  individuals with higher caloric needs may exceed this limit,
                  while those with lower caloric intakes should strive to stay
                  within this range, following the 80/20 rule.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  It's important to note that if most of your sugar intake comes
                  from fruits, you may exceed the 100 gram limit. Consider this
                  figure as a ballpark estimate to be mindful of rather than a
                  strict universal limit.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Now you may be curious about how all of this will impact your
                  body recomposition goals. In the next chapters, we will
                  provide guidance on organizing your macronutrient intake
                  around training to optimize your gym performance and recovery.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>CARB SOURCES LIST:</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <i>
                  Whole wheat bread, oatmeal, brown rice, long grain rice, all
                  rice derivatives (i.e. cream of rice, rice crisp cereal, etc.)
                  legumes (peas, beans, etc.), starchy vegetables (potatoes,
                  carrots, corn), quinoa, bulgur (wheat derivatives), all fruit
                  (kiwi, bananas, apples, oranges, etc.), all berries
                  (raspberries, blueberries, blackberries, etc.), all fibrous
                  vegetables (broccoli, spinach, kale, lettuce, etc.)
                </i>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Low Fat? Low Carb? Or Neither?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Throughout history, fats and carbohydrates have experienced
                alternating periods of praise and demonization. Presently,
                within the fitness community, there appears to be a division
                between those who vilify carbohydrates and those who demonize
                fats.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, it is important to avoid categorizing either nutrient
                as inherently "good" or "bad" without delving into their
                respective roles in the body. We firmly believe that both
                carbohydrates and fats have significant roles in fueling
                training performance and facilitating positive changes in body
                composition.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                To simplify matters, fats are essential for our survival, while
                carbohydrates are not. This means that we need to consume
                dietary fat, whereas our metabolism can adapt to the absence of
                carbohydrates by utilizing ketone bodies as the primary energy
                source (although we won't delve into this topic in detail in
                this course). However, just because we can survive without carbs
                does not mean that eliminating them from our diet is the most
                effective approach for body recomposition.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Carbohydrates often face more criticism in the current fitness
                landscape, and unfortunately, many individuals still believe
                that consuming dietary fat directly leads to body fat storage.
                There is a prevalent fear that "eating fat will make them fat."
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>{`In reality, dietary fat serves numerous vital functions in the human body beyond being stored as adipose tissue. It plays a crucial role in regulating metabolic processes, hormone production, and facilitating the absorption and utilization of certain vitamins (A, D, E, & K). Given the multitude of metabolic pathways that rely on the availability of fat, fearing fat may actually impede your body recomposition goals rather than support them.`}</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Perhaps a simple change in terminology, such as referring to
                dietary fat as dietary lipids and body fat as adipose tissue,
                could help shift this negative association.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                We strongly advise against eliminating any macronutrient
                entirely when body recomposition is the goal. Instead, all three
                macronutrients should be consumed in a balanced manner, tailored
                to the individual's needs and goals. Harmonious inclusion of
                proteins, fats, and carbohydrates at appropriate intake levels
                is key.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How much Fat Should You Eat For Recomp ?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The recommended fat intake for body recomposition depends on
                three key factors: your current body fat percentage, activity
                level, and personal preferences.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                We generally advise that 20-35% of your total calories should
                come from dietary fat. By ensuring your fat intake never falls
                below 20%, you reduce the risk of deficiencies in fat-soluble
                vitamins and negative hormonal effects like reduced
                testosterone.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Insulin sensitivity is closely related to body fat percentage,
                as discussed in more detail in our carbohydrate section. The
                higher your body fat percentage, the lower your insulin
                sensitivity. Consequently, individuals with higher body fat
                levels should aim for the higher end of the recommended fat
                intake range (20-35% of total calories).
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Your activity level also plays a role in determining your fat
                intake. More active individuals can utilize carbohydrates more
                efficiently for energy, so a lower fat intake may be beneficial.
                On the other hand, those with less active lifestyles may benefit
                from a higher fat and lower carbohydrate intake.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For example, let's consider identical twins with the same
                height, weight, and body composition. If one twin has a
                sedentary office job while the other works as a waiter with high
                physical activity levels, the waiter twin would likely benefit
                from a lower fat, higher carbohydrate approach. We would suggest
                the office twin stay closer to 35% fat intake, while the waiter
                twin should aim for around 20% fat intake.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Considering personal preferences is crucial to ensure adherence
                to your dietary plan. If you enjoy eating higher fat foods and
                don't crave carbohydrates as much, a higher fat diet may be more
                suitable for you. Conversely, if you prefer carbohydrates and
                tend to choose low-fat foods, take that into account when
                setting your macronutrient goals.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Once you determine your fat and protein intake, you can fill in
                the remaining calories of your daily goal with carbohydrates.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How Much Carbohydrate Should We Eat For Recomp?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Carbohydrates are the body's preferred energy source and play a
                crucial role in optimizing training performance. Restricting
                carbohydrates excessively can negatively impact strength
                training. Additionally, there is a relationship between body fat
                percentage and insulin resistance, indicating that individuals
                with higher body fat levels should reduce carbohydrate intake
                and increase fat consumption. Conversely, leaner individuals can
                consume more carbohydrates and less fat.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                In addition to considering your activity level, NEAT
                (non-exercise activity thermogenesis), lifestyle, and dietary
                preferences, it is crucial to prioritize sustainability and
                adherence when determining your carbohydrate intake. Let's
                outline the step-by-step process for calculating your calorie
                and macro targets for body recomposition.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>STEP-BY-STEP GUIDE FOR SETTING UP RECOMP MACROS:</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 block text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold font-dm-sans">{`Step 1: `}</i>
                  <i>{`Weigh yourself and calculate your body fat % (via BIA, Skin Calipers, DEXA, or guesstimation) `}</i>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold font-dm-sans">Step 2.</i>
                  <i className="font-dm-sans">{` Calculate LBM: Bodyweight x (0.XX as % of lean mass) i.e. if you weigh 170lbs at 15% bodyfat, you have 85% lean mass. Your LBM would be: 170lbs x 0.85 = 144.5lbs LBM `}</i>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold font-dm-sans">Step 3:</i>
                  <i className="font-dm-sans">{` Estimate your Basal Metabolic Rate (BMR) using the according to Mifflin St. Jeor Formula or (more roughly) bodyweight(lbs) x 10. `}</i>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold font-dm-sans">Step 4:</i>
                  <i className="font-dm-sans">{` Apply the appropriate activity multiplier to determine your theoretical maintenance calories. Alternatively, use a 2 week guess-and-check method to determine maintenance calories. `}</i>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold font-dm-sans">Step 5:</i>
                  <i className="font-dm-sans">{` Determine whether you should be in a caloric surplus, caloric deficit or at maintenance to drive body recomposition. Apply the surplus/deficit to your theoretical maintenance to determine your recomp calorie intake. (Important step!) `}</i>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold font-dm-sans">Step 6:</i>
                  <i className="font-dm-sans">{` Set up your protein intake by multiplying your LBM by 1.2-1.6 (closer to 1.6 the leaner you are). `}</i>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold font-dm-sans">Step 7:</i>
                  <i className="font-dm-sans">{` Determine what percentage of calories should come from fat (20-35%). Closer to 20 percent the leaner you are. `}</i>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold font-dm-sans">Step 8:</i>
                  <i className="font-dm-sans">{` Calculate your fat intake by multiplying your recomp calorie intake by the percentage in Step 7 and dividing by 9. (9 calories per gram of fat) `}</i>
                </span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  <i className="font-bold font-dm-sans">Step 9:</i>
                  <i className="font-dm-sans">{` Calculate your “remaining calories” by subtracting the calories from protein (protein intake x 4) and the calories from fat (fat intake x 9). `}</i>
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>
                  <i className="font-bold font-dm-sans">Step 10:</i>
                  <i className="font-dm-sans">
                    {" "}
                    Calculate your carb intake from the “remaining calories” by
                    dividing by 4. (4 calories per gram of carbs)
                  </i>
                </span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson35"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson34;
